import { Action } from '@reduxjs/toolkit';
import { combineEpics, StateObservable } from 'redux-observable';
import { of, Observable } from 'rxjs';
import {
  filter, pluck, mergeMap, distinctUntilChanged, map,
} from 'rxjs/operators';

import { NO_MORE_BETS, PLACE_YOUR_BETS, GAME_RESULT } from '@ezugi/constants';

import { roundActions, soundActions } from '../../actions';
import { LOSE } from '../../constants/gameResults';
import { gameResultSelector, isRussianPokerSelector } from '../../selectors';
import { noWinBelowBetSelector } from '../../selectors/mixed';
import { RootState } from '../../types';

const { round } = roundActions;
const { sound } = soundActions;

const resetWinnerList = (action$: Observable<Action>) => action$.pipe(
  filter(round.set.match),
  filter(({ payload }) => payload.roundStatus === NO_MORE_BETS),
  map(() => round.set({
    winnerList: [],
  }))
);

const checkShouldCelebrate = (action$: Observable<Action>, state$: StateObservable<RootState>) => action$.pipe(
  filter(round.set.match),
  pluck('payload'),
  distinctUntilChanged(),
  filter(({ roundStatus }) => {
    let shouldTriggerCelebration = true;
    if (isRussianPokerSelector(state$.value)) {
      shouldTriggerCelebration = gameResultSelector(state$.value)?.HandEvaluatorResult !== LOSE;
    }
    return roundStatus === GAME_RESULT && noWinBelowBetSelector(state$.value) && shouldTriggerCelebration;
  }),
  mergeMap(() => of(
    round.set({
      shouldCelebrate: true,
    }),
    sound.play({
      spriteName: 'base_sprite',
      soundName: 'win',
    })
  ))
);

export const resetShouldCelebrate = (action$: Observable<Action>) => action$.pipe(
  filter(round.set.match),
  pluck('payload'),
  filter(({ roundStatus }) => roundStatus === PLACE_YOUR_BETS),
  map(() => round.set({
    shouldCelebrate: false,
  }))
);

export default combineEpics(resetWinnerList, checkShouldCelebrate, resetShouldCelebrate);
